import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MergeOrganizationsParams, MergeOrganizationsResponse } from './types';

export async function mergeOrganizations(params: MergeOrganizationsParams) {
  const url = '/web/studio/organizations/merge';

  /* eslint-disable camelcase */
  const body = {
    organization_ids: params.organizationIds,
    merge_into_organization_id: params.mergeIntoOrganizationId,
  };
  /* eslint-enable camelcase */

  const response = await api.executePostRequest<ObjectResponse<MergeOrganizationsResponse>>(url, body);

  return response.data;
}
